// src/vocabulary/B1/unit4/content.js

const content = {
  level: "B1",
  unit: 4,
  title: "Describing People (Character)",
  description:
    "Words used to describe personality and character. Learn how to talk about how people behave and act.",

  explanation: [
    "This unit focuses on describing people's character and personality.",
    "Character words describe how a person behaves, not how they look.",
    "These words are often used with the verb 'to be'.",
    "For example: He is kind. She is very friendly.",
    "You can use these words to describe friends, family, or coworkers.",
    "Some character traits are positive, and some are negative.",
    "Talking about personality helps you explain how someone usually acts.",
    "Try to describe people you know using these words."
  ],

  items: [
    {
      word: "kind",
      phonetic: "/kaɪnd/",
      meaning: "لطيف / طيب",
      example: "She is very kind to everyone."
    },
    {
      word: "friendly",
      phonetic: "/ˈfrendli/",
      meaning: "ودود",
      example: "He is friendly and easy to talk to."
    },
    {
      word: "polite",
      phonetic: "/pəˈlaɪt/",
      meaning: "مهذب",
      example: "The waiter was very polite."
    },
    {
      word: "lazy",
      phonetic: "/ˈleɪzi/",
      meaning: "كسول",
      example: "He is lazy on weekends."
    },
    {
      word: "hard-working",
      phonetic: "/ˌhɑːrd ˈwɜːrkɪŋ/",
      meaning: "مجتهد",
      example: "She is a hard-working student."
    },
    {
      word: "honest",
      phonetic: "/ˈɒnɪst/",
      meaning: "صادق",
      example: "People trust him because he is honest."
    }
  ]
};

export default content;


